import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import CustomCanvasConfetti from "../../../UI/Confetti";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const CreateQuizPopUp= ({closeQuizPopUp,setParentFolderItem,menuOrder})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizName, setQuizName] = useState("");
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({ID:""});
        const [fireConfetti, setFireConfetti] = useState(false);
        
    const userdata = useSelector((state)=>state?.user?.user);
    useEffect(()=>{
      
     
     },[])
   useEffect(()=>{

    if(setParentFolderItem?.ID){
      setParentFolder(setParentFolderItem)
    }
   },[])
   
     const handleCreateNewMockTest=()=>{
     
     
     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest({testName:quizName,type:"mock",
         postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
         currentToken:currentToken?currentToken:"",
         editType:"",postId:"",menuOrder:menuOrder,appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){  
           if(response?.quiz){
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
       setFireConfetti(true) 
       setTimeout(()=>{
        setQuizObject(response?.quiz)
           setFireConfetti(false) 
            
         },3000)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
   
       return <>
       
   
 
   {/* {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  */}
    <div style={{position:"absolute",zIndex:"9999999999"}}> {fireConfetti && ( 
        <CustomCanvasConfetti AnimType="firework" />
        
        // <CustomCanvasConfetti AnimType="cannon" />
      )} 
</div>
 <div   onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>closeQuizPopUp(false)} className="appDesignPopUpOpacity"  style={{zIndex:98,cursor:"pointer"}}> </div>
        <div   className="AreYouSurePopUp" style={{height:"400px",borderRadius: '20px',zIndex:99}}> 
        <h2 align="center" >   What Is The  <span className="coloredTextV1" >Name Of Your Quiz?</span> </h2>
      
 
<div className="bookmarkListScroll" style={{overflowY:"auto",height:"280px",overflowX:"hidden"}}>

    <div className="">
    
  
   <div >
    
<div style={{} }>
<div  className="" >
<div  className="ikcraft_login-input-card">
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style= {{fontSize:"25px"}} placeholder={`Add Quiz Name`} type="text"
  rows={2} name="courseTitle" value={quizName} onChange={(e)=>setQuizName(e.target.value)} />
 </div></div>
 
 {parentFolder?.ID?<div className=" " > 
<h3 align="center">
  
   Quiz Will Be Added To This Folder
  
  </h3>
<label className={"radio-outer"}  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}>
<div  className="courseContentItemOuterHeadActiveSettings" style={{marginTop:"0px",paddingLeft:"10px",border:"2px solid #f1f1f1" ,background:"#ffffff"}}>
<div className="courseContentItemJustifyContentIcons"  style={{borderRadius:"5px", padding:"5px",paddingLeft:"15px",paddingTop:"8px",marginTop:"2px",position:"relative"}}> 
                                    
<input type={"radio"} 
            className="input-textbox"    checked name={"quizFolderRadio"}  

/>
              <span class={"circle"}></span>                       
                                                                
             
<img     src={contentfolder} 
        alt="selected Img"
   style={{cursor:"pointer",width:"25px",height:"25px",paddingLeft:"15px",marginTop:"-7px"
    
   }}/> </div><div className="courseContentItemJustifyContent"> <div className="themeNone "
 style={{fontSize:"15px",color:"#111",fontWeight:"700"}}> 
  {parentFolder?.Name}
 
      </div></div><div  className="courseContentItemOuterHeadActiveSettingsInn"
 style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
  <div></div><div></div><div></div><div>{!setParentFolderItem?.ID?<Trash2 onClick={()=>{ setParentFolder({ID:""});;
}}  onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} strokeWidth={2} absoluteStrokeWidth  size={18} 
 color="#666666" style={{padding:"4px",background:"#ffffff",borderRadius:"5px",cursor:"pointer"}}/>:""}</div>
 </div>
 <div></div></div> </label></div>: <div className="" style={{paddingBottom:"50px",marginBottom:"90px"}}> 
       <div className="" style={{borderRadius:"25px",padding:"5px",}}> 
 <div >  <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Select A Folder For  <span className="coloredTextV1" > This Quiz </span> </h2></div>
      <div className="gridFiftyFixed" style={{marginBottom:"30px"}}>
      <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUp(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Select
 A Folder </div>    <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUpCreateFolder(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Create New
  Folder </div> </div>
  </div>
  {/* <div className="gridForFiftyFixed"style={{
        transform: animate ? 'scale(1)' : 'scale(.98)',background:"transparent",border:"0px solid #fff",
        opacity: animate ? 1 : 0.8,
        transition: 'transform 2s ease, opacity 2s ease',
      }}><div >  <h2 >  Sell This Quiz In  <span className="coloredTextV1" > Seperate Test Series </span>??? </h2></div>
      <div style={{paddingTop:"10px"}} >
      <Toggle state={sellAsTestSeries} toggleState={(state)=>{setSellAsTestSeries(state)}} />
      </div>
 </div> */}


                               {/* {!sellAsTestSeries?
                               <div className="" style={{borderRadius:"25px",padding:"5px",}}> 
 <div >  <h2 style={{"textAlign":"center",
        transform: animate ? 'translateY(0)' : 'translateY(-10px))',
        opacity: animate ? 1 : 0.8,
        transition: 'transform 1s ease, opacity 1s ease',
      }}>  Select A Folder For  <span className="coloredTextV1" > This Quiz </span> </h2></div>
      <div className="gridFiftyFixed" style={{marginBottom:"30px"}}>
      <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUp(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Select
 A Folder </div>    <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{setFolderForQuizPopUpCreateFolder(true)}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
    ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
    fontSize:"17px",borderRadius:"5px",color:"#222"
 ,cursor:"pointer"}}>Create New
  Folder </div> </div>
  </div>

        :<div className="" style={{borderRadius:"25px",padding:"5px",}}> 
        <div >  <h2 style={{"textAlign":"center",
               transform: animate ? 'translateY(0)' : 'translateY(-10px))',
               opacity: animate ? 1 : 0.8,
               transition: 'transform 1s ease, opacity 1s ease',
             }}>  Select Test Series   </h2></div>
              <div className="gridFiftyFixed" style={{marginBottom:"30px"}}>
      <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
  ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
  fontSize:"17px",borderRadius:"5px",color:"#222"
,cursor:"pointer"}}>Select
 Test Series </div>    <div align="center" onMouseEnter={handleMouseEnter}
           onMouseLeave={handleMouseLeave} onClick={()=>{}} 
 color="#222" style={{padding:"12px",background:"rgba(144, 202, 249,0.1)"
  ,border:"2px solid rgba(144, 202, 249,1)",width:"85%",fontWeight:"999",
  fontSize:"17px",borderRadius:"5px",color:"#222"
,cursor:"pointer"}}>+ Create
  Test Series </div> </div></div>} */}


 </div>
 
 }
 </div>
{folderForQuizPopUp?<FolderForQuiz  setFolderRadioItemBack={(value)=>{setParentFolder(value);setFolderForQuizPopUp(false)}} closeFolderForQuiz={()=>{setFolderForQuizPopUp(false)}}/>:""}
{folderForQuizPopUpCreateFolder?<FolderForQuiz setFolderRadioItemBack={(value)=>{setParentFolder(value);setFolderForQuizPopUpCreateFolder(false)}} setCreateNewFolderStatus={"openPopUp"} closeFolderForQuiz={()=>{setFolderForQuizPopUpCreateFolder(false)}}/>:""}

{/* <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',fontSize:'12px',marginBottom:'10px'}}>
    <div  >   </div>
  
    
    <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{zIndex:99999,cursor:"pointer"}} onClick={()=>closeQuizPopUp(false)}   className="CreateCourseStepsOuterRightButtonBack"  type="submit"
     id="signupBtn"> Close</button>

 <button onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest()}} style={{width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} className="CreateCourseStepsOuterRightButton"  type="submit"
     id="signupBtn"> {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":quizID?"Update":"Save"} </button>
     
  </div> */}

</div>





</div>

<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"18px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>closeQuizPopUp(false)}    className=" CoursesPreviewTopBtn"  type="submit"
 > Cancel </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest();}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Click To  Create"} </button>
</div> 
</div>

     </div>

     {quizObject?.ID?<QuizSetUpOuter quizObject={quizObject}  setQuizObjectDataBack={(data)=>{setQuizObject(data)}} closeQuizPopUp={()=>{closeQuizPopUp(false)}}/>:""}
     <div>
     </div>

    
     
     </>


}
export default CreateQuizPopUp;